import React from "react";

const COMPANY_LINKS = [
  { label: "About Us", href: "https://www.uslawshield.com/about-us-2/" },
  {
    label: "Frequently Asked Questions",
    href: "https://www.uslawshield.com/faq/",
  },
  { label: "Coverage", href: "https://www.uslawshield.com/coverage/" },
  { label: "Upcoming Events", href: "https://www.uslawshield.com/seminar/" },
  { label: "Join Our Team", href: "https://www.uslawshield.com/employment/" },
  {
    label: "Anti-Discrimination",
    href: "https://www.uslawshield.com/anti-discrimination/",
  },
  { label: "Contact Us", href: "https://www.uslawshield.com/contact-us/" },
];

const RESOURCE_LINKS = [
  { label: "Education", href: "https://www.uslawshield.com/education/" },
  { label: "News", href: "https://www.uslawshield.com/blog-2/" },
  {
    label: "Video Library",
    href: "https://www.uslawshield.com/video-library/",
  },
  { label: "Manage My Account", href: "https://members.uslawshield.com/" },
];

const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/USLawShield",
    icon: "M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z",
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/channel/UCzD8X6Dr-tBEy0Y_WiXlvmQ",
    icon: "M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88.46-8.6.92a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19.1c1.72.46 8.6.9 8.6.9s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.87zM9.75 15.02V8.48l5.75 3.27-5.75 3.27z",
  },
  {
    label: "Twitter",
    href: "https://twitter.com/uslawshield",
    icon: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/uslawshield/",
    icon: "M16 4H8a4 4 0 00-4 4v8a4 4 0 004 4h8a4 4 0 004-4V8a4 4 0 00-4-4zm2.5 12A2.5 2.5 0 0116 18.5H8A2.5 2.5 0 015.5 16V8A2.5 2.5 0 018 5.5h8a2.5 2.5 0 012.5 2.5v8zM12 8.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 5.5a2 2 0 110-4 2 2 0 010 4zm4.5-6a1 1 0 11-2 0 1 1 0 012 0z",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/us-law-shield/",
    icon: "M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-4 0v7h-4v-7a6 6 0 016-6zM2 9h4v12H2zM4 2a2 2 0 110 4 2 2 0 010-4z",
  },
];

const USLSFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#1B2A4A] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-2">
              {COMPANY_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm hover:text-white transition-colors"
                  >
                    &rsaquo; {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">
              Resources
            </h4>
            <ul className="space-y-2">
              {RESOURCE_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm hover:text-white transition-colors"
                  >
                    &rsaquo; {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Call Us */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">
              Call Us
            </h4>
            <a
              href="tel:1-877-448-6839"
              className="text-2xl font-bold text-white hover:text-gray-300 transition-colors"
            >
              877-448-6839
            </a>
            <p className="text-sm mt-2">
              <strong>Mon-Fri:</strong> 8:00AM-8:00PM CST
            </p>
            <p className="text-sm">
              <strong>Sat-Sun:</strong> 8:30AM-5:00PM CST
            </p>
            <div className="flex gap-3 mt-4">
              {SOCIAL_LINKS.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label={link.label}
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d={link.icon} />
                  </svg>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-600">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <img
              src="/USLSlogonobackground.png"
              alt="U.S. LawShield"
              className="h-12 w-auto"
            />
            <p className="text-xs text-gray-400 text-center md:text-left">
              U.S. Law Shield, LLC, Texas Law Shield, LLC, and affiliated
              entities are headquartered in Houston, Texas. We are not a law
              firm. Terms, conditions, and restrictions apply.{" "}
              <a
                href="https://www.uslawshield.com/terms-and-conditions/"
                className="underline hover:text-white"
              >
                Click for more information
              </a>
              , including affiliated entities and license information.
            </p>
          </div>
          <div className="mt-4 text-center md:text-left text-xs text-gray-500">
            &copy; Copyright {year} U.S. LawShield | All Rights Reserved |{" "}
            <a
              href="https://www.uslawshield.com/terms-and-conditions/"
              className="hover:text-white"
            >
              Terms and Conditions
            </a>{" "}
            |{" "}
            <a
              href="https://www.uslawshield.com/privacy-policy/"
              className="hover:text-white"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default USLSFooter;
